/* cro-cinematic.js v1.5.7 — tầng motion M3 "Cinematic": scroll-scrub CHUỖI KHUNG (render Blender) trên <canvas>,
 * beat chữ theo tiến độ cuộn, tier thiết bị, bảo vệ đường mua. Vanilla, không thư viện, idempotent.
 * Đi cặp cro-cinematic.css + đoạn boot inline trong <head> (README §1). Nạp `defer` MỘT lần/trang.
 *
 *  <section class="cro-seq" data-cro-seq
 *           data-cro-seq-src="https://cdn.../hero_{i}.webp"      {i} = số khung, đệm 0 theo -pad
 *           data-cro-seq-count="120" data-cro-seq-pad="3" data-cro-seq-start="1"
 *           data-cro-seq-src-lite="https://cdn.../hero-m_{i}.webp" data-cro-seq-count-lite="60"
 *           data-cro-seq-step-lite="2"                         (tuỳ) bộ lite nhảy khung trên CÙNG bộ file (Shopify Files + ?width=)
 *           data-cro-seq-src-portrait="https://cdn.../hero-v_{i}.webp" data-cro-seq-count-portrait="60"
 *                                                              (tuỳ, v1.2) bộ khung DỌC render riêng (camera 9:16): chọn theo
 *                                                              HƯỚNG màn (cao ≥ rộng, khớp CSS orientation: portrait), không theo
 *                                                              tier — máy ngang yếu vẫn dùng bộ lite ngang. Poster dọc: <picture>.
 *           data-cro-seq-length="250" data-cro-seq-length-lite="180">   chiều dài ghim (vh); lite mặc định min(length, 200)
 *    (KHÔNG nút Skip/Pause trên khối: anh bỏ 17-10, modules/cinematic-web.md §0b)
 *    <div class="cro-seq__stage">
 *      <img class="cro-seq__poster" src="…hero_001.webp" width height alt="…" fetchpriority="high">   ← ứng viên LCP
 *      <canvas class="cro-seq__canvas" aria-hidden="true"></canvas>
 *      <div class="cro-seq__beat" data-cro-beat="0.05-0.3">…chữ thật…</div>
 *    </div>
 *  </section>
 *
 * NỀN 3D CỐ ĐỊNH (v1.4, 17-10 — "3D xuyên suốt cả trang", §0b): khối KHÔNG ghim, sân khấu fixed sau các section nội dung bên dưới
 *  <div class="cro-seq cro-seq--backdrop" data-cro-seq data-cro-seq-backdrop
 *       data-cro-seq-until="#cta-cuoi"                         p = 1 khi ĐỈNH phần tử này chạm đỉnh màn; sau đó sân khấu trôi lên theo nó
 *       data-cro-seq-marks=".range@0.14, .ritual@0.5"          (tuỳ) đỉnh phần tử chạm đỉnh màn ↔ tiến độ khung — chương theo section
 *       data-cro-seq-marks-portrait="…"                       (tuỳ, v1.5.4) mốc riêng khi chạy bộ khung DỌC (camera dọc ra/vào khung lúc khác)
 *       data-cro-seq-src=… data-cro-seq-count=… (+ -portrait/-lite như trên)>
 *    <div class="cro-seq__stage"><canvas class="cro-seq__canvas" aria-hidden="true"></canvas></div>
 *  </div>
 *  p = 0 khi đỉnh khối chạm đỉnh màn (đặt khối NGAY SAU khối ghim, khung 1 = khung cuối khối ghim → chỗ nối không thấy). Sân khấu chỉ
 *  hiện khi khối đã vào màn tới lúc phần tử `until` ra khỏi màn; section nội dung phía sau phải nằm TRÊN nó (position + z-index ≥1,
 *  nền trong suốt khi <html>.cro-cine-backdrop — runtime đặt lớp này; static/no-JS/runtime hỏng = không có lớp → nền section đặc).
 *  Không tính là ghim (không bật .cro-cine-pinned), không tải khung tới khi người xem còn cách ≤2.5 màn.
 *
 * PHIM CẢ TRANG (v1.5, 17-10 — chạy live trước ở ecom84.com): một phim Blender chạy suốt trang, MỖI CHƯƠNG MỘT CẢNH, khung nối theo
 * MỐC của từng chương (không tuyến tính theo chiều cao trang — chương dài/ngắn khác nhau giữa desktop và mobile vẫn khớp cảnh).
 *  <div class="cro-seq cro-seq--backdrop cro-seq--film" data-cro-seq data-cro-seq-film
 *       data-cro-seq-until="#film-end"                         phần tử KẾT: p = 1 khi ĐỈNH nó chạm ĐÁY màn, sau đó sân khấu trôi lên theo nó
 *       data-cro-seq-film-in=".chapter__in"                    (tuỳ) phần tử NỘI DUNG trong chương để canh mốc; mặc định [data-cro-film-in]
 *       data-cro-seq-src=… (+ -lite / -portrait)>             → con đầu tiên của chương → chính chương
 *    <div class="cro-seq__stage"><img class="cro-seq__poster" …><canvas class="cro-seq__canvas" aria-hidden="true"></canvas></div>
 *  </div>
 *  <section class="chapter" data-cro-film="0.32" data-cro-film-y="0.68|0.55">…</section>   (y tuỳ chọn, "ngang|dọc")
 *  Mốc chương: màn NGANG = tâm chương ở giữa màn (có y ngang: đỉnh nội dung ở y × màn) · màn DỌC = đỉnh nội dung ở y dọc × màn
 *  (mặc định 0.55: vật 3D nửa trên, chữ ngay dưới). Đầu trang p = 0. data-cro-seq-film tự bật chế độ nền (khỏi cần -backdrop);
 *  khác nền thường: sân khấu HIỆN ngay từ đầu trang (phim là hero), mốc lấy từ chương, phần tử `until` tính theo ĐÁY màn.
 *  Mốc tính lại khi đổi cỡ màn / load / thân trang đổi chiều cao (ResizeObserver), không đọc layout mỗi khung cuộn.
 *
 * MƯỢT (v1.5, anh 17-10 "ko mượt" → "fps cao hơn mà vẫn nhanh"; đo ecom84: hình đổi 12 → 56 lần/s): vị trí hình là SỐ THỰC đuổi theo
 *  cuộn (quán tính τ = data-cro-seq-ease ms, mặc định 80; 0 = tắt), vẽ khung dưới rồi phủ khung trên alpha = phần lẻ (hoà khung;
 *  data-cro-seq-blend="off" để tắt); dừng cuộn 140 ms thì trôi về khung nguyên gần nhất (không để ảnh hoà hai khung đứng yên).
 *  debug().shown = vị trí đang hiện. Khung dày (24–30 khung / màn cuộn) + hoà khung = mượt; ít khung hơn thì hoà khung lộ bóng mờ.
 * VÁ KHUNG (v1.5): render lại một đoạn phim → chỉ tải lên khung đổi, tên mới:
 *  data-cro-seq-patch="150-184,200" + data-cro-seq-patch-src="https://…/film-v2_{i}.webp" (mỗi bộ có hậu tố riêng: -lite / -portrait).
 *
 * Luật đã thành code (mỗi luật = một check của scripts/audit/cinematic-gate.mjs):
 *  1. Poster-first: poster là <img> thật, hiện tới khi canvas ĐÃ vẽ khung đầu → LCP không phụ thuộc JS/canvas.
 *  2. Không tải khung trước `load` (trừ poster); khung tải tinh dần (bước 16→8→4→2→1) → scrub dùng được sớm.
 *  3. Không chiếm cuộn: chỉ nghe `scroll` passive; không wheel/touchmove; cuộn là của trình duyệt.
 *  4. Tier: static (reduce-motion · Save-Data · 2g · máy ≤1GB · không canvas) = bố cục tĩnh, mọi beat hiện;
 *     lite (màn <768 · RAM <4GB · CPU <4 · mạng 3g) = bộ khung nhẹ + ghim ngắn hơn; full = bộ khung đủ.
 *     (NN/g: ghim dài trên mobile làm mất phương hướng → lite tự rút ghim về ≤200vh.)
 *  5. Đường mua: khi một khối đang ghim → <html>.cro-cine-pinned (CSS ép thanh mua [data-cro-buybar] hiện).
 *  6. Khuất màn → không vẽ, không nghe cuộn (IO). Tab ẩn → không vẽ.
 *  7. Bộ nhớ: khung giữ dạng NÉN (Blob), chỉ giải mã cửa sổ ±12 khung (lite ±8) bằng createImageBitmap, ngoài cửa sổ close().
 *     Giữ hết khung đã giải mã (ImageBitmap hay <img>) = 120 khung 1440p ≈ 560 MB → iOS Safari giết tab. (v1.1, 16-10)
 * Theme editor Shopify: shopify:section:load/unload → init/destroy theo section; section:select → tắt ghim của khối đó
 * (editor phải cuộn tới và GIỮ section được chọn trong khung), deselect → bật lại.
 */
(function () {
  'use strict';
  if (window.CroCinematic) return;
  var doc = document.documentElement;
  var mm = function (q) { return window.matchMedia ? window.matchMedia(q).matches : false; };
  var hasIO = 'IntersectionObserver' in window;
  var stats = { draws: 0, framesRequested: 0, framesLoaded: 0, framesRequestedBeforeLoad: 0, pinnedMs: 0 };
  var loaded = document.readyState === 'complete';
  var live = [];
  var CONCURRENCY = 6;
  // fetch() gửi Accept: */* — CDN ảnh Shopify (và nhiều CDN chọn định dạng theo Accept) khi đó trả JPEG: đo 16-10 trên store thật
  // khung WebP 16.8 KB về thành JPEG 56.6 KB (3.4×). Gửi Accept như <img> của Chrome (header an toàn CORS, không preflight). X175
  var IMG_ACCEPT = 'image/avif,image/webp,image/apng,image/*,*/*;q=0.8';

  function detectTier() {
    var forced = doc.getAttribute('data-cro-cine');
    if (forced === 'static' || forced === 'lite' || forced === 'full') return forced;
    if (mm('(prefers-reduced-motion: reduce)')) return 'static';
    var c = navigator.connection || {};
    if (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')) return 'static';
    var mem = navigator.deviceMemory || 8, cpu = navigator.hardwareConcurrency || 8;
    if (mem <= 1) return 'static';
    try { if (!document.createElement('canvas').getContext('2d')) return 'static'; } catch (e) { return 'static'; }
    if ((window.innerWidth || doc.clientWidth) < 768 || mem < 4 || cpu < 4 || c.effectiveType === '3g') return 'lite';
    return 'full';
  }
  var TIER = detectTier();

  function setTierClass() {
    doc.classList.remove('cro-cine-full', 'cro-cine-lite', 'cro-cine-static');
    doc.classList.add('cro-cine-' + TIER);
    if (TIER === 'static') doc.classList.remove('cro-cine-on'); else doc.classList.add('cro-cine-on');
  }

  // bộ khung: dọc (màn dọc + có bộ dọc) > lite (tier lite + có bộ lite) > full. Chốt lúc init như tier (xoay máy giữa chừng: giữ bộ cũ, fit lo phần cắt)
  function frameSet(el) {
    var tall = (window.innerHeight || doc.clientHeight) >= (window.innerWidth || doc.clientWidth);
    if (tall && el.getAttribute('data-cro-seq-src-portrait')) return '-portrait';
    // v1.5.6 (22-10, anh: "khá mờ"): desktop màn ≥ 1,5× (Mac retina) + tier full + có bộ -retina (khung 2560) → bộ retina, canvas trần 5 MP
    if (!tall && TIER === 'full' && (window.devicePixelRatio || 1) >= 1.5 && el.getAttribute('data-cro-seq-src-retina')) return '-retina';
    if (TIER === 'lite' && el.getAttribute('data-cro-seq-src-lite')) return '-lite';
    return '';
  }

  function frameUrls(el) {
    var k = frameSet(el), at = function (n) { return el.getAttribute('data-cro-seq-' + n + k); };
    var src = at('src');
    var count = parseInt(at('count'), 10);
    var pad = parseInt(el.getAttribute('data-cro-seq-pad') || '0', 10);
    var start = parseInt(el.getAttribute('data-cro-seq-start') || '1', 10);
    var step = Math.max(1, parseInt(at('step') || '1', 10) || 1);
    if (!src || !(count > 1)) return [];
    var out = [], num = function (i) { var n = String(start + i * step); while (n.length < pad) n = '0' + n; return n; };
    for (var i = 0; i < count; i++) out.push(src.replace('{i}', num(i)));
    // v1.5 vá khung: số thứ tự khung (1 = khung đầu bộ) trong data-cro-seq-patch → lấy từ data-cro-seq-patch-src (cùng số trong tên)
    var psrc = at('patch-src'), pr = String(at('patch') || '').split(',');
    if (psrc) for (var r = 0; r < pr.length; r++) {
      var ab = pr[r].split('-'), a = parseInt(ab[0], 10), b = parseInt(ab[1] || ab[0], 10);
      for (var j = a; j <= b; j++) if (j >= 1 && j <= count) out[j - 1] = psrc.replace('{i}', num(j - 1));
    }
    return out;
  }

  function parseBeats(el) {
    var list = el.querySelectorAll('[data-cro-beat]'), out = [];
    for (var i = 0; i < list.length; i++) {
      var r = String(list[i].getAttribute('data-cro-beat')).split('-');
      var a = parseFloat(r[0]), b = parseFloat(r[1]);
      if (!isNaN(a) && !isNaN(b)) out.push({ el: list[i], a: a, b: b, on: false });
    }
    return out;
  }

  // Giải mã theo CỬA SỔ (16-10, research B): iOS Safari giới hạn bộ nhớ canvas/ảnh ~224–384 MB, 120 khung 1440p giải mã hết
  // ≈ 560 MB. Khung giữ dạng NÉN (Blob ~30 KB); chỉ ±WIN khung quanh vị trí hiện tại được createImageBitmap (giải mã ngoài
  // luồng chính), ra ngoài cửa sổ → close(). Không có createImageBitmap/fetch, khung khác origin không CORS, hay khung không
  // giải mã được dạng bitmap (SVG) → lùi về <img> cho khung đó.
  var CAN_BMP = typeof window.createImageBitmap === 'function' && typeof window.fetch === 'function';
  var WIN = TIER === 'full' ? 12 : 8, AHEAD = TIER === 'full' ? 6 : 4;

  function Seq(el) {
    this.el = el;
    this.stage = el.querySelector('.cro-seq__stage') || el;
    this.canvas = el.querySelector('.cro-seq__canvas');
    this.poster = el.querySelector('.cro-seq__poster');
    // nền canvas = data-cro-seq-bg || nền của stage; trong suốt → canvas alpha (khung PNG/WebP có alpha đè lên nền trang)
    var bg = el.getAttribute('data-cro-seq-bg') || getComputedStyle(this.stage).backgroundColor;
    this.bg = /^(transparent|rgba\([^)]*,\s*0\))$/.test(bg || 'transparent') ? null : bg;
    this.ctx = this.canvas ? this.canvas.getContext('2d', { alpha: !this.bg }) : null;
    this.set = frameSet(el).slice(1) || 'full';
    this.urls = frameUrls(el);
    this.blobs = new Array(this.urls.length);      // khung NÉN (đường chính)
    this.imgs = new Array(this.urls.length);       // khung <img> (đường lui) — đã giải mã, không đuổi
    this.bmps = {};                                // idx → { bmp } trong cửa sổ
    this.have = 0;
    this.beats = parseBeats(el);
    this.p = 0; this.idx = -1; this.drawn = -1; this.near = false; this.started = false; this.pinned = false;
    this.film = el.hasAttribute('data-cro-seq-film');               // v1.5 phim cả trang = nền cố định + mốc chương
    this.backdrop = this.film || el.hasAttribute('data-cro-seq-backdrop'); this.active = false; this.soon = false;
    var ease = parseFloat(el.getAttribute('data-cro-seq-ease'));
    this.ease = isNaN(ease) ? 80 : Math.max(0, ease); this.blend = el.getAttribute('data-cro-seq-blend') !== 'off';
    // v1.5.7 (22-10): data-cro-seq-skip="t0-t1,…" = đoạn phim (0..1) mà khung đã render sẵn HOÀ 2 cảnh (film_merge xfade) → không vẽ khung trong
    // đoạn, cắt thẳng sang khung sạch gần nhất (anh: "artifact và ghosting khi lướt"; AD: chai kép ~250 ms mỗi cú nhảy chương). Mọi bộ khung dùng chung t.
    this.skip = (el.getAttribute('data-cro-seq-skip') || '').split(',').map(function (s) { var m = s.split('-').map(parseFloat); return m.length === 2 && m[0] < m[1] ? m : null; }).filter(Boolean);
    // v1.5.6 (22-10): data-cro-seq-ahead = số khung giải mã TRƯỚC theo hướng cuộn (mặc định 6 full / 4 lite); cửa sổ giữ bitmap nới theo (≥ ahead + 4)
    var ah = parseInt(el.getAttribute('data-cro-seq-ahead'), 10);
    this.ahead = ah > 0 ? Math.min(16, ah) : AHEAD; this.win = Math.max(WIN, this.ahead + 4);
    this.fp = -1; this.tf = 0; this.shown = null; this.lastT = 0; this.idleAt = 0; this.prevTf = -1;
    if (this.film) { this.filmIn = el.getAttribute('data-cro-seq-film-in') || '[data-cro-film-in]'; this.fa = null; el.classList.add('cro-seq--film'); }
    if (this.backdrop) {                                           // v1.4: nền cố định — không ghim, không --cro-seq-len
      this.until = el.getAttribute('data-cro-seq-until') || '';
      // v1.5.4: bộ khung dọc render bằng camera dọc → SP rời/vào khung ở tiến độ khác bộ ngang → mốc riêng (không có thì dùng mốc chung)
      var mk = (this.set === 'portrait' && el.getAttribute('data-cro-seq-marks-portrait')) || el.getAttribute('data-cro-seq-marks') || '';
      this.marks = String(mk).split(',').map(function (m) {
        // "sel@f" = đỉnh phần tử chạm ĐỈNH màn ↔ f · "sel@f@enter" (v1.5.2) = vừa vào từ ĐÁY màn · "sel@f@0.45" = đỉnh ở 45 % chiều cao màn
        var q = m.split('@'), an = (q[2] || '').trim(), av = an === 'enter' ? 1 : parseFloat(an);
        return q.length >= 2 && q[0].trim() ? { sel: q[0].trim(), f: parseFloat(q[1]), at: isNaN(av) ? 0 : Math.min(1, Math.max(0, av)) } : null;
      }).filter(function (m) { return m && m.sel && !isNaN(m.f); });
      doc.classList.add('cro-cine-backdrop');
    } else {
      var len = parseFloat(el.getAttribute('data-cro-seq-length')) || 250;
      if (TIER === 'lite') len = parseFloat(el.getAttribute('data-cro-seq-length-lite')) || Math.min(len, 200);
      if (len > 100) el.style.setProperty('--cro-seq-len', len + 'vh');
    }
    this.resize();
  }

  Seq.prototype.resize = function () {
    if (!this.canvas) return;
    var box = this.backdrop ? this.canvas : this.stage;            // nền: canvas cao 100svh như sân khấu ghim (khớp chỗ nối)
    var w = box.clientWidth, h = box.clientHeight;
    // v1.3 (17-10): data-cro-seq-dpr-lite (tuỳ) nâng trần DPR của tier lite (điện thoại màn 3x: 1.5 = canvas 585 px, ảnh phóng 2x → mờ).
    // Không đặt = y như cũ (trang live dựng trước đó không đổi).
    var dprLite = parseFloat(this.el.getAttribute('data-cro-seq-dpr-lite')) || 0;
    var dpr = Math.min(window.devicePixelRatio || 1, TIER === 'full' ? 2 : (dprLite || 1.5));
    var maxPx = TIER === 'full' || dprLite ? (this.set === 'retina' ? 5.0e6 : 3.2e6) : 1.6e6;            // trần điểm ảnh canvas (RAM + fill-rate); bộ retina 5 MP
    var scale = Math.min(dpr, Math.sqrt(maxPx / Math.max(1, w * h)));
    this.canvas.width = Math.max(1, Math.round(w * scale));
    this.canvas.height = Math.max(1, Math.round(h * scale));
    this.drawn = -1;
  };

  // tải tinh dần: bước 16, 8, 4, 2, 1 — mỗi bước lấp khung chưa có → scrub dùng được sớm, mịn dần
  Seq.prototype.start = function () {
    if (this.started || !this.urls.length) return;
    this.started = true;
    var order = [], seen = {}, n = this.urls.length;
    [16, 8, 4, 2, 1].forEach(function (s) { for (var i = 0; i < n; i += s) if (!seen[i]) { seen[i] = 1; order.push(i); } });
    if (!seen[n - 1]) order.push(n - 1);
    var self = this, k = 0, inflight = 0;
    function viaImg(i, done) {
      var img = new Image(); img.decoding = 'async';
      img.onload = function () { var fin = function () { self.imgs[i] = img; done(true); }; if (img.decode) img.decode().then(fin, fin); else fin(); };
      img.onerror = function () { done(false); };
      img.src = self.urls[i];
    }
    function one(i, done) {
      if (!CAN_BMP || self.noFetch) return viaImg(i, done);
      fetch(self.urls[i], { credentials: 'same-origin', headers: { Accept: IMG_ACCEPT } }).then(function (r) {
        if (!r.ok) return null;                                    // 404/5xx = khung thật sự không có, đừng tải lại bằng <img>
        return r.blob();
      }).then(function (b) { if (b) { self.blobs[i] = b; done(true); } else done(false); },
        function () { self.noFetch = true; viaImg(i, done); });   // lỗi mạng/CORS → cả khối dùng <img>
    }
    function pump() {
      while (inflight < CONCURRENCY && k < order.length) {
        (function (i) {
          inflight++;
          stats.framesRequested++; if (!loaded) stats.framesRequestedBeforeLoad++;
          one(i, function (ok) {
            inflight--;
            if (ok) { self.have++; stats.framesLoaded++; if (Math.abs(i - self.idx) <= WIN || self.drawn < 0) schedule(); }
            pump();
          });
        })(order[k++]);
      }
    }
    pump();
  };

  Seq.prototype.decode = function (i) {
    if (i < 0 || i >= this.urls.length || this.bmps[i] || !this.blobs[i] || (this.skip.length && this.skipped(i))) return;
    var self = this, e = { bmp: null };
    this.bmps[i] = e;
    createImageBitmap(this.blobs[i]).then(function (b) {
      if (self.bmps[i] !== e) { if (b.close) b.close(); return; }          // bị đuổi trước khi giải mã xong
      e.bmp = b; if (Math.abs(i - self.idx) <= self.ahead) schedule();
    }, function () {                                                        // không giải mã được dạng bitmap → <img>
      if (self.bmps[i] === e) delete self.bmps[i];
      var img = new Image(), blob = self.blobs[i];
      img.onload = function () { self.imgs[i] = img; self.blobs[i] = null; schedule(); };
      img.src = URL.createObjectURL(blob);
    });
  };

  Seq.prototype.evict = function (c) {
    for (var k in this.bmps) {
      if (Math.abs(k - c) <= this.win) continue;
      var e = this.bmps[k]; if (e.bmp && e.bmp.close) e.bmp.close();
      delete this.bmps[k];
    }
  };

  Seq.prototype.source = function (i) { return (this.bmps[i] && this.bmps[i].bmp) || this.imgs[i] || null; };

  Seq.prototype.skipped = function (i) {                          // v1.5.7: khung i nằm trong đoạn hoà cảnh (data-cro-seq-skip)?
    var n = this.urls.length - 1;
    for (var q = 0; q < this.skip.length; q++) if (i >= Math.ceil(this.skip[q][0] * n) && i <= Math.floor(this.skip[q][1] * n)) return true;
    return false;
  };
  Seq.prototype.nearest = function (i) {                          // đường lùi khi khung đích chưa giải mã: không bao giờ chọn khung hoà cảnh
    if (this.source(i) && !this.skipped(i)) return i;
    for (var d = 1; d < this.urls.length; d++) {
      if (i - d >= 0 && this.source(i - d) && !this.skipped(i - d)) return i - d;
      if (i + d < this.urls.length && this.source(i + d) && !this.skipped(i + d)) return i + d;
    }
    return -1;
  };

  // v1.4 nền cố định: tiến độ nối khúc theo vị trí cuộn — [đỉnh khối → 0] · [đỉnh mark → f] · [đỉnh `until` → 1]
  Seq.prototype.measureBackdrop = function () {
    var vh = window.innerHeight || doc.clientHeight, y = window.pageYOffset || doc.scrollTop || 0;
    var top = this.el.getBoundingClientRect().top, end = this.until ? document.querySelector(this.until) : null;
    var er = end ? end.getBoundingClientRect() : null;
    // v1.5.1: data-cro-seq-from="enter" — p = 0 khi khối VỪA vào màn (đáy màn), không đợi chạm đỉnh: hình chạy liền ngay lúc nối khối ghim
    var from = this.el.getAttribute('data-cro-seq-from') === 'enter' ? vh : 0;
    var pts = [[top + y - from, 0]];
    for (var i = 0; i < this.marks.length; i++) {
      var m = document.querySelector(this.marks[i].sel);
      if (m) pts.push([m.getBoundingClientRect().top + y - this.marks[i].at * vh, Math.min(1, Math.max(0, this.marks[i].f))]);
    }
    var endY = er ? er.top + y : top + y + vh;
    pts.push([endY, 1]);
    this.range = [Math.round(top + y), Math.round(endY)];
    pts.sort(function (a, b) { return a[0] - b[0]; });
    for (var q2 = 1; q2 < pts.length; q2++) if (pts[q2][1] < pts[q2 - 1][1]) pts[q2][1] = pts[q2 - 1][1];   // tiến độ không lùi
    var p = 0;
    if (y >= pts[pts.length - 1][0]) p = 1;
    else for (var k = 1; k < pts.length; k++) {
      if (y < pts[k][0]) { var a = pts[k - 1], b = pts[k], t = (y - a[0]) / Math.max(1, b[0] - a[0]); p = y <= a[0] ? a[1] : a[1] + (b[1] - a[1]) * t; break; }
    }
    this.p = Math.min(1, Math.max(0, p));
    this.idx = Math.round(this.p * (this.urls.length - 1));
    this.pinned = false;
    var on = top < vh && (er ? er.bottom > 0 : top > -vh);
    // v1.5.5 (R9 17-10: chỗ nối chớp 2–3 khung hình — nền chưa giải mã khung 0 → trong suốt; quay lại từ cuối trang → khung cũ 158 hiện tạm):
    // kích hoạt = bỏ vị trí cũ (fp), chưa "tươi" (canvas ẩn, khối ghim CHƯA ẩn hình) tới khi vẽ được khung ±1 của khung hiện tại
    if (on !== this.active) { this.active = on; this.el.classList.toggle('is-active', on); if (on) { this.drawn = -1; this.fp = -1; this.fresh = false; this.el.classList.remove('is-fresh'); } }
    this.soon = top < vh * 2.5 && (er ? er.bottom > -vh : true);
    if (this.soon && loaded && !this.started) this.start();
    if (!on && this.soon && this.started && this.idx >= 0) { this.decode(this.idx); this.decode(this.idx + 1); }   // giải mã sẵn khung sắp hiện
    // sau p = 1 sân khấu trôi lên cùng phần tử `until` (không phủ footer); trước đó đứng yên (chỗ nối với khối ghim không thấy)
    var lift = er && er.top < 0 ? Math.round(er.top) : 0;
    if (lift !== this.lift) { this.lift = lift; this.stage.style.transform = lift ? 'translate3d(0,' + lift + 'px,0)' : ''; }
  };

  // v1.5 phim: mốc [y cuộn, tiến độ] của từng chương — tính khi đổi cỡ / load / thân trang đổi cao, KHÔNG mỗi khung cuộn
  Seq.prototype.filmCalc = function () {
    var vh = window.innerHeight || doc.clientHeight, vw = window.innerWidth || doc.clientWidth, y = window.pageYOffset || doc.scrollTop || 0;
    var tall = vh >= vw, pts = [[0, 0]], list = document.querySelectorAll('[data-cro-film]');
    for (var i = 0; i < list.length; i++) {
      var ch = list[i], t = parseFloat(ch.getAttribute('data-cro-film')); if (isNaN(t)) continue;
      var r = ch.getBoundingClientRect(), inn = (ch.querySelector(this.filmIn) || ch.firstElementChild || ch).getBoundingClientRect();
      var yy = String(ch.getAttribute('data-cro-film-y') || '').split('|'), lv = parseFloat(yy[0]), pv = parseFloat(yy[1]);
      var at = tall ? inn.top + y - vh * (pv || 0.55) : (lv ? inn.top + y - vh * lv : r.top + y + r.height / 2 - vh / 2);
      pts.push([Math.max(0, at), Math.min(1, Math.max(0, t))]);
    }
    var u = this.until ? document.querySelector(this.until) : null;
    this.fEnd = u ? u.getBoundingClientRect().top + y : (document.documentElement.scrollHeight || 0);
    pts.push([Math.max(0, this.fEnd - vh), 1]);
    pts.sort(function (a, b) { return a[0] - b[0]; });
    for (var k = 1; k < pts.length; k++) if (pts[k][1] < pts[k - 1][1]) pts[k][1] = pts[k - 1][1];   // tiến độ không lùi
    this.fa = pts; this.range = [0, Math.round(Math.max(0, this.fEnd - vh))];
  };

  Seq.prototype.measureFilm = function () {
    if (!this.fa) this.filmCalc();
    var vh = window.innerHeight || doc.clientHeight, y = window.pageYOffset || doc.scrollTop || 0, A = this.fa, p = 1;
    if (y <= A[0][0]) p = A[0][1];
    else for (var k = 1; k < A.length; k++) if (y <= A[k][0]) { var a = A[k - 1], b = A[k]; p = a[1] + (b[1] - a[1]) * ((y - a[0]) / Math.max(1, b[0] - a[0])); break; }
    this.p = Math.min(1, Math.max(0, p));
    this.idx = Math.round(this.p * (this.urls.length - 1));
    this.pinned = false;
    // hết phim: phần tử `until` vào từ đáy màn → sân khấu trôi lên cùng nó (footer bên dưới hiện tự nhiên, không tắt đột ngột)
    var lift = Math.min(0, Math.round(this.fEnd - y - vh)), on = lift > -vh;
    if (on !== this.active) { this.active = on; this.el.classList.toggle('is-active', on); this.el.classList.toggle('is-off', !on); if (on) this.drawn = -1; }
    this.soon = true;
    if (loaded && !this.started) this.start();
    if (lift !== this.lift) { this.lift = lift; this.stage.style.transform = lift ? 'translate3d(0,' + lift + 'px,0)' : ''; }
  };

  Seq.prototype.measure = function () {
    if (this.film) return this.measureFilm();
    if (this.backdrop) return this.measureBackdrop();
    var r = this.el.getBoundingClientRect(), vh = window.innerHeight || doc.clientHeight;
    var span = Math.max(1, r.height - vh);
    this.p = Math.min(1, Math.max(0, -r.top / span));
    this.pinned = r.top <= 0 && r.bottom >= vh;
    this.idx = Math.round(this.p * (this.urls.length - 1));
  };

  Seq.prototype.fitDraw = function (src) {
    var cw = this.canvas.width, ch = this.canvas.height, iw = src.naturalWidth || src.width, ih = src.naturalHeight || src.height;
    var fit = this.el.getAttribute('data-cro-seq-fit') === 'contain' ? Math.min : Math.max;   // cover mặc định
    var s = fit(cw / iw, ch / ih), dw = iw * s, dh = ih * s;
    this.ctx.drawImage(src, (cw - dw) / 2, (ch - dh) / 2, dw, dh);
  };

  Seq.prototype.paint = function () {
    var ps = this.p.toFixed(4);
    if (ps !== this.ps) { this.ps = ps; this.el.style.setProperty('--cro-p', ps); }
    for (var b = 0; b < this.beats.length; b++) {
      var bt = this.beats[b], on = this.p >= bt.a && this.p <= bt.b;
      if (on !== bt.on) { bt.on = on; bt.el.classList.toggle('is-on', on); }
    }
    if (!this.ctx || document.hidden || this.idx < 0 || (this.backdrop && !this.active)) return;
    // v1.5 MƯỢT: vị trí hình fp (số thực) đuổi theo tf = p × (n−1) với quán tính τ = ease; dừng cuộn 140 ms → về khung nguyên gần nhất
    var n = this.urls.length - 1, now = performance.now(), dt = Math.min(64, this.lastT ? now - this.lastT : 16);
    this.lastT = now; this.tf = this.p * n;
    if (this.tf !== this.prevTf) { this.prevTf = this.tf; this.idleAt = now + 140; }
    var goal = this.blend && now <= this.idleAt ? this.tf : Math.round(this.tf), fp = this.fp < 0 ? goal : this.fp;
    fp = this.ease > 0 ? fp + (goal - fp) * (1 - Math.exp(-dt / this.ease)) : goal;
    if (Math.abs(goal - fp) < 0.004 || Math.abs(goal - fp) > 30) fp = goal;   // tới nơi · nhảy xa (link neo, tải giữa trang) thì khỏi trôi
    this.fp = fp;
    var i0 = Math.max(0, Math.min(n, Math.floor(fp))), a = fp - i0, i1 = Math.min(n, i0 + 1);
    for (var q = 0; q < this.skip.length; q++) {                                   // đoạn hoà cảnh: nửa đầu giữ khung trước đoạn, nửa sau khung sau đoạn
      var lo = Math.ceil(this.skip[q][0] * n), hi = Math.floor(this.skip[q][1] * n);
      if (i0 >= lo && i0 <= hi) { i0 = fp - lo < hi + 1 - fp ? Math.max(0, lo - 1) : Math.min(n, hi + 1); a = 0; i1 = i0; break; }
    }
    var dir = this.fp >= 0 && this.tf < this.fp ? -1 : 1;
    for (var d = 0; d <= this.ahead; d++) { this.decode(i0 + dir * d); if (d <= 3) this.decode(i0 - dir * d); }
    this.decode(this.idx);
    var A = this.source(i0), B = this.blend && a > 0.01 && i1 !== i0 ? this.source(i1) : null, src = A, key, shown;
    if (A) { this.evict(i0); key = B ? i0 + Math.round(a * 48) / 48 : i0; shown = B ? i0 + a : i0; }   // đuổi khi khung đích đã sẵn
    else { var j = this.nearest(i0); if (j < 0) return; src = this.source(j); key = shown = j; }        // chưa giải mã: khung gần nhất
    if (key !== this.drawn) {
      var cw = this.canvas.width, ch = this.canvas.height;
      if (this.bg) { this.ctx.fillStyle = this.bg; this.ctx.fillRect(0, 0, cw, ch); } else this.ctx.clearRect(0, 0, cw, ch);
      this.fitDraw(src);
      if (A && B) { this.ctx.globalAlpha = a; this.fitDraw(B); this.ctx.globalAlpha = 1; }   // hoà khung: khung trên phủ theo phần lẻ
      this.drawn = key; this.shown = shown; stats.draws++;
      if (!this.el.classList.contains('is-drawn')) this.el.classList.add('is-drawn');   // poster lui SAU khi canvas có hình
    }
    if (this.backdrop && !this.fresh && this.drawn !== -1 && Math.abs(this.shown - i0) <= 1) { this.fresh = true; this.el.classList.add('is-fresh'); schedule(); }
    if (fp !== goal || (this.blend && now <= this.idleAt + 30)) schedule();         // còn trôi / chưa hết 140 ms chờ → khung sau vẽ tiếp
  };

  // Thả bitmap đã giải mã (giữ Blob nén): tab ẩn / pagehide. WebKit 295618 (iOS 18.4–26.1): bitmap không báo chi phí bộ nhớ cho GC →
  // Safari tự tải lại tab sau vài phút; kỹ sư WebKit khuyên close() ngay khi không cần (research C, 16-10). Canvas vẫn giữ khung cuối.
  Seq.prototype.dropBitmaps = function () {
    for (var k in this.bmps) { var e = this.bmps[k]; if (e.bmp && e.bmp.close) e.bmp.close(); }
    this.bmps = {}; this.drawn = -1;
  };

  Seq.prototype.release = function () {
    this.dropBitmaps(); this.blobs = []; this.imgs = [];
    // iOS giữ backing store của canvas tới khi GC → thu về 1×1 khi gỡ section (pqina: total canvas memory limit)
    if (this.canvas) { this.canvas.width = 1; this.canvas.height = 1; }
  };

  // khối ghim ngay TRƯỚC khối nền (cùng cha, hoặc section bao ngay trước — Shopify), bỏ qua script/style/link chen giữa
  function linkPrev(b) {
    for (var e = b.el, lv = 0; e && lv < 3; lv++, e = e.parentElement) {
      var sib = e.previousElementSibling;
      while (sib && /^(SCRIPT|STYLE|LINK|NOSCRIPT)$/.test(sib.tagName)) sib = sib.previousElementSibling;
      if (!sib) continue;
      var a = sib.matches && sib.matches('[data-cro-seq]') ? sib : (sib.querySelector ? sib.querySelector('[data-cro-seq]') : null);
      return a && a.__croSeq && !a.__croSeq.backdrop ? a.__croSeq : null;
    }
    return null;
  }

  var rafPending = false;
  Seq.prototype.queue = function () { schedule(); };
  function schedule() {
    if (rafPending) return; rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      var anyPinned = false;
      for (var i = 0; i < live.length; i++) {
        var s = live[i]; if (!s.near) continue;
        s.measure(); s.paint(); if (s.pinned) anyPinned = true;
      }
      // v1.5.1 NỐI khối ghim → nền: khối nền đặt NGAY SAU khối ghim; khi nền kích hoạt, khối ghim ẩn hình (canvas/poster/nền sân khấu),
      // giữ chữ — màn chỉ còn hình nền (khung 1 = khung cuối khối ghim, cùng chỗ) → không thấy hai cụm SP chồng nhau lúc khối ghim trôi lên
      for (var h = 0; h < live.length; h++) {
        var bd = live[h]; if (!bd.backdrop || bd.film) continue;
        if (!bd.prev) bd.prev = linkPrev(bd);
        if (bd.prev) { var ho = !!bd.active && !!bd.fresh; if (ho !== bd.prev.handoff) { bd.prev.handoff = ho; bd.prev.el.classList.toggle('is-handoff', ho); } }   // v1.5.5: chờ nền vẽ xong
      }
      if (anyPinned !== doc.classList.contains('cro-cine-pinned')) doc.classList.toggle('cro-cine-pinned', anyPinned);
    });
  }

  var nearIO = hasIO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var s = e.target.__croSeq; if (!s) return;
      s.near = e.isIntersecting;
      if (s.near && loaded) s.start();
      schedule();
    });
  }, { rootMargin: '150% 0px 150% 0px' }) : null;

  function init(root) {
    root = root || document;
    if (TIER === 'static') return;
    var list = root.querySelectorAll('[data-cro-seq]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i]; if (el.__croSeq) continue;
      var s = new Seq(el); el.__croSeq = s; live.push(s);
      if (s.film && filmRO && document.body) filmRO.observe(document.body);
      if (s.backdrop) s.near = true;                               // nền: measureBackdrop tự quyết hiện/tải (khối cao 0, IO không hợp)
      else if (nearIO) nearIO.observe(el); else { s.near = true; if (loaded) s.start(); }
    }
    doc.classList.add('cro-cine-ready');
    schedule();
  }

  function destroy(root) {
    for (var i = live.length - 1; i >= 0; i--) {
      if (root && !root.contains(live[i].el)) continue;
      if (nearIO) nearIO.unobserve(live[i].el);
      live[i].release(); live[i].el.__croSeq = null; live.splice(i, 1);
    }
    for (var k = 0; k < live.length; k++) if (live[k].backdrop) return;
    doc.classList.remove('cro-cine-backdrop');
  }

  setTierClass();
  window.addEventListener('scroll', function () { if (live.length) schedule(); }, { passive: true });
  // SmartFilm #119 (30/10/2026): themes that scroll an inner box instead of the window (Shopify Horizon ≥ 990 px: html/body
  // height 100dvh + overflow hidden, .page-wrapper scrolls) never fire window 'scroll'; element scroll events do not bubble but do
  // pass the capture phase on document → listen there too. Layout math is viewport-relative (getBoundingClientRect), so it holds.
  document.addEventListener('scroll', function (e) { if (live.length && e.target !== document) schedule(); }, { passive: true, capture: true });
  var rz; window.addEventListener('resize', function () {
    clearTimeout(rz); rz = setTimeout(function () {
      var t = detectTier();
      if ((t === 'static') !== (TIER === 'static')) return;           // đổi bố cục giữa chừng = CLS; giữ tier lúc tải
      for (var i = 0; i < live.length; i++) { live[i].resize(); live[i].fa = null; }
      schedule();
    }, 150);
  }, { passive: true });
  // phim: thân trang đổi chiều cao (font, ảnh, block tải muộn) → mốc chương tính lại ở khung sau
  var filmRO = 'ResizeObserver' in window ? new ResizeObserver(function () { var any = false; for (var i = 0; i < live.length; i++) if (live[i].film) { live[i].fa = null; any = true; } if (any) schedule(); }) : null;
  window.addEventListener('load', function () {
    loaded = true;
    for (var f = 0; f < live.length; f++) live[f].fa = null;
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 200); };
    idle(function () { for (var i = 0; i < live.length; i++) if (live[i].near && (!live[i].backdrop || live[i].soon)) live[i].start(); schedule(); });
  });
  var dropAll = function () { for (var i = 0; i < live.length; i++) live[i].dropBitmaps(); };
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { dropAll(); return; }                     // tab ẩn: trả RAM; hiện lại: paint() giải mã lại cửa sổ từ Blob
    for (var i = 0; i < live.length; i++) live[i].drawn = -1; schedule();
  });
  window.addEventListener('pagehide', dropAll);
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });   // quay lại từ bfcache
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
  var editing = function (on) { return function (e) { var l = e.target.querySelectorAll ? e.target.querySelectorAll('[data-cro-seq]') : []; for (var i = 0; i < l.length; i++) l[i].classList.toggle('is-editing', on); schedule(); }; };
  document.addEventListener('shopify:section:select', editing(true));
  document.addEventListener('shopify:section:deselect', editing(false));

  window.CroCinematic = {
    tier: TIER, init: init, destroy: destroy, stats: stats,
    // chỉ đọc cho công cụ QA (contract api.t / scrollFor): tiến độ phim hiện tại · y cuộn của tiến độ t theo mốc chương
    t: function () { for (var i = 0; i < live.length; i++) if (live[i].film) return live[i].p || 0; return 0; },
    scrollFor: function (t) {
      for (var i = 0; i < live.length; i++) if (live[i].film) {
        var s = live[i]; if (!s.fa) s.filmCalc(); var A = s.fa;
        for (var k = 1; k < A.length; k++) if (t <= A[k][1]) { var a = A[k - 1], b = A[k]; return a[0] + (b[0] - a[0]) * ((t - a[1]) / Math.max(1e-6, b[1] - a[1])); }
        return A[A.length - 1][0];
      }
      return 0;
    },
    debug: function () {
      return live.map(function (s) {
        // decodedMB = bitmap trong cửa sổ + mọi khung <img> đường lui (khung nén không tính: ~30 KB/khung)
        var px = 0, nb = 0;
        for (var k in s.bmps) if (s.bmps[k].bmp) { px += s.bmps[k].bmp.width * s.bmps[k].bmp.height; nb++; }
        for (var i = 0; i < s.imgs.length; i++) if (s.imgs[i]) px += s.imgs[i].naturalWidth * s.imgs[i].naturalHeight;
        return { p: s.p, idx: s.idx, drawn: s.drawn, set: s.set, frames: s.urls.length, loaded: s.have, pinned: s.pinned, bitmaps: nb, mode: s.noFetch || !CAN_BMP ? 'img' : 'bitmap', decodedMB: Math.round(px * 4 / 1e6),
          backdrop: s.backdrop, active: s.backdrop ? s.active : undefined, range: s.backdrop ? s.range : undefined,
          film: s.film, marks: s.film && s.fa ? s.fa.map(function (m) { return [Math.round(m[0]), m[1]]; }) : undefined,
          shown: s.shown, blend: s.blend, ease: s.ease };
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
})();
